export default __webpack_public_path__ + "static/media/icon-piece-jointe-blanc.b0b6e978.svg";